<style>
.cont-form .vs__dropdown-toggle {
  background: #fff;
}

.card-plan-free {
  border-radius: 5px;
  box-shadow: 0px 5px 15px var(--alpha-black);
  padding: 10px;
}

.btn-card-plan {
  position: absolute;
  bottom: 15px;
  width: 90%;
}

.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.line-title {
  border: 0px solid rgb(237, 130, 12);
  border-width: 3px;
  margin: 5px auto 10px;
  width: 80px;
}
</style>

<template>
  <div class="guia-profissional-geral">
    
    <div class="guia-head pb-50">
      <div class="container">
        <!-- Breadcrumb -->
        <div class="row p-25">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" id="inicio">
                  <router-link class="text-uppercase" :to="{ name: 'home' }">
                    Início
                  </router-link>
                </li>
                <li
                  class="breadcrumb-item active text-uppercase"
                  aria-current="page"
                >
                  Guia de Profissionais
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <!-- Guia head -->
        <div class="row">
          <!-- Título da Sessão -->
          <div class="col-12 text-center mb-4">
            <h1 class="h1-after-center text-uppercase fwb mb-5">
              Guia de Profissionais
            </h1>
            <p class="roboto-n text-center">
              A Constr Up, buscou de uma maneira rápida e fácil te oferecer os
              prestadores de serviço da sua região, é só escolher a cidade e o
              serviço que deseja.
            </p>
            <p class="fs-14 roboto-n text-center c-orange">
              <span class="fwb">Atenção! </span>A Constr Up não se
              responsabiliza pelos serviços prestados. Apresentamos apenas os
              prestadores de serviço de sua região.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="guia-pesquisa py-1">
      <div class="cont-form bg-gray-3 p-3 mb-5" style="min-width: 250px">
        <form>
          <div class="form-row align-items-end">
            <div class="col-xl-5 mb-md-0 mb-2">
              <label class="c-white" for="inputCidade"
                >Selecione a Cidade</label
              >
              <v-select
                v-model="pesquisar.cidade"
                label="nome"
                :options="cidades"
                :reduce="(cidades) => cidades.id"
                placeholder="Digite uma cidade"
              >
                <div slot="no-options">
                  Desculpe, ainda não estamos nessa cidade!
                </div>
              </v-select>
            </div>
            <div class="col-xl-5 mb-md-0 mb-2">
              <label class="c-white" for="inputServico"
                >Selecione o tipo de serviço</label
              >
              <v-select
                v-model="pesquisar.profissao"
                label="nome"
                :options="tipoProfissoes"
                :reduce="(tipoProfissoes) => tipoProfissoes.id"
                placeholder="Digite um serviço"
              >
                <div slot="no-options">
                  Desculpe, ainda não temos esse serviço!
                </div>
              </v-select>
            </div>
            <div class="text-center col-xl-2">
              <div class="btn bg-orange c-white" @click="searchProfissionais()">
                Pesquisar
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="text-center mb-5">
        <router-link
          class="c-orange no-text-decoration"
          :to="{ name: 'cadastro', params: { type: UserTypes.PROFESSIONAL } }"
        >
          <span class="c-black d-block fs-24">
            É profissional e quer anunciar grátis?
          </span>
          <hr class="line-title w-25 text-orange" />
          <div
            class="btn bg-orange c-white fs-24 mt-3 text-uppercase w-35 mb-4"
          >
            Cadastrar-se
          </div>
        </router-link>
      </div>
    </div>
    <!-- Special cards -->
    <div v-if="profissionaisDestaques">
      <div
        class="guia-destaques p-50 bg-gray-2"
        v-if="profissionaisDestaques.length > 0"
      >
        <div class="container">
          <!-- Cards em Destaques-->
          <div class="row">
            <div class="col-12 text-center mb-3">
              <h1 class="text-uppercase text-highlight font-weight-bold mb-5">
                <i class="fas fa-star mr-2"></i>
                Destaques
                <i class="fas fa-star ml-2"></i>
              </h1>
            </div>
            <div
              class="col-lg-3 col-md-6 mb-5"
              v-for="(profissionalDestaque, index) in profissionaisDestaques"
              :key="index"
            >
              <div class="card-proff-sm">
                <div class="star">
                  <i class="fas fa-star fs-16 c-white"></i>
                  <span class="fs-14 text-uppercase c-white">Destaque</span>
                </div>
                <div class="box-img">
                  <img
                    class="obj my-img-fluid w-100 h-100"
                    :src="
                      `${getImagesAddress}` +
                      profissionalDestaque.foto_principal
                    "
                    alt
                    v-if="profissionalDestaque.foto_principal !== null"
                  />
                  <img
                    class="obj max-obj-contain my-img-fluid w-100 h-100"
                    src="@/assets/img/Logo Novo ConstrUp.png"
                    alt
                    v-else
                  />
                </div>
                <div class="box-info pt-2">
                  <p
                    class="fs-16 font-weight-bold mb-2"
                    v-if="profissionalDestaque.nome_fantasia !== null"
                  >
                    {{ profissionalDestaque.nome_fantasia }}
                  </p>
                  <p class="fs-14 fwb mb-2" v-else>
                    {{ profissionalDestaque.nome }}
                  </p>
                  <div v-if="profissionalDestaque.profissoes !== null">
                    <i class="fas fa-user fs-14 c-black mr-1"></i>
                    <span
                      class="roboto-n fs-14"
                      v-for="(
                        profissao, index
                      ) in profissionalDestaque.profissoes"
                      :key="index"
                    >
                      {{ profissao.nome }}
                      {{
                        parseInt(index + 1) !==
                        profissionalDestaque.profissoes.length
                          ? ':'
                          : ''
                      }}
                    </span>
                  </div>
                  <div v-else>
                    <i class="fas fa-user fs-14 c-black mr-1"></i>
                    <span class="roboto-n fs-14">Sem Profissão</span>
                  </div>
                  <div
                    v-if="
                      profissionalDestaque.cidade !== null &&
                      profissionalDestaque.estado !== null
                    "
                  >
                    <i class="fas fa-map-marker-alt fs-14 c-black mr-2"></i>
                    <span class="roboto-n fs-14">
                      {{ profissionalDestaque.cidade.nome }} -
                      {{ profissionalDestaque.estado.uf }}
                    </span>
                  </div>
                  <div
                    v-if="
                      profissionalDestaque.celular !== null &&
                      profissionalDestaque.celular !== ''
                    "
                  >
                    <i class="fab fa-whatsapp fs-14 c-black mr-1"></i>
                    <a href="tel:+" class="roboto-n fs-14 c-black">
                      <the-mask
                        class="desinput"
                        v-model="profissionalDestaque.celular"
                        :mask="['(##) #####-####', '(##) ####-####']"
                        readonly
                      />
                    </a>
                  </div>
                  <router-link
                    class="btn fs-18 btn-highlight c-white mt-3 btn-card-plan"
                    :to="{
                      name: 'guia-profissionais-single',
                      params: { id: profissionalDestaque.id },
                    }"
                    >Ver profissional</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Paginação -->
          <div class="row" v-if="!checkIsEmpty(profissionaisDestaques)">
            <div class="col-12">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item">
                    <div
                      class="page-link c-orange"
                      @click="paginacaoProfDesc(paginaProfDestAtual - 1)"
                      aria-label="Previous"
                      v-if="paginaProfDestAtual > 1"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </div>
                  </li>
                  <li
                    class="page-item"
                    v-for="(pagPD, index) in profDestPaginacao"
                    :key="index"
                  >
                    <div
                      class="page-link c-black"
                      @click="paginacaoProfDesc(pagPD)"
                    >
                      {{ pagPD }}
                    </div>
                  </li>
                  <li class="page-item">
                    <div
                      class="page-link c-orange"
                      @click="paginacaoProfDesc(paginaProfDestAtual + 1)"
                      aria-label="Next"
                      v-if="paginaProfDestAtual < profDestPaginacao.length"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Normal cards -->
    <div
      class="guia-destaques py-5"
      v-if="profissionais !== undefined && profissionais.length !== 0"
    >
      <div class="container">
        <!-- Cards normal -->
        <div class="row">
          <div
            class="col-lg-3 col-md-6 mb-5"
            v-for="(profissional, index) in profissionais"
            :key="index"
          >
            <div
              v-if="profissional.plano_id !== ProfessionalPlans.FREE"
              class="card-proff-sm"
            >
              <div class="star" v-if="profissional.plano_id === 3">
                <i class="fas fa-star fs-16 c-white"></i>
                <span class="fs-14 text-uppercase c-white">Destaque</span>
              </div>
              <div class="box-img">
                <img
                  class="my-img-fluid w-100 h-100"
                  :src="`${getImagesAddress}` + profissional.foto_principal"
                  v-if="profissional.foto_principal !== null"
                />
                <img
                  class="obj max-obj-contain my-img-fluid w-100 h-100"
                  src="@/assets/img/Logo Novo ConstrUp.png"
                  v-else
                />
              </div>
              <div class="box-info mt-2">
                <p
                  class="fs-16 font-weight-bold mb-2 text-overflow"
                  v-if="profissional.nome_fantasia !== null"
                >
                  {{ profissional.nome_fantasia }}
                </p>
                <p class="fs-16 font-weight-bold mb-2" v-else>
                  {{ profissional.nome }}
                </p>
                <div v-if="profissional.profissoes !== null">
                  <i class="fas fa-user fs-14 c-black mr-1"></i>
                  <span
                    class="roboto-n fs-14"
                    v-for="(profissao, index) in profissional.profissoes"
                    :key="index"
                  >
                    {{ profissao.nome }}
                    {{
                      parseInt(index + 1) !== profissional.profissoes.length
                        ? ','
                        : ''
                    }}
                  </span>
                </div>
                <div v-else>
                  <i class="fas fa-user fs-14 c-black mr-1"></i>
                  <span class="roboto-n fs-14">Sem Profissão</span>
                </div>
                <div
                  v-if="
                    profissional.cidade !== null && profissional.estado !== null
                  "
                >
                  <i class="fas fa-map-marker-alt fs-14 c-black mr-2"></i>
                  <span class="roboto-n fs-14">
                    {{ profissional.cidade.nome }} -
                    {{ profissional.estado.uf }}
                  </span>
                </div>
                <div
                  v-if="
                    profissional.celular !== null && profissional.celular !== ''
                  "
                >
                  <i class="fab fa-whatsapp fs-14 c-black mr-1"></i>
                  <a
                    :href="'tel:+' + profissional.celular"
                    class="roboto-n fs-14 c-black"
                  >
                    <the-mask
                      class="desinput"
                      v-model="profissional.celular"
                      :mask="['(##) #####-####', '(##) ####-####']"
                      readonly
                    />
                  </a>
                </div>
                <router-link
                  class="btn fs-18 btn-normal c-white mt-3 btn-card-plan"
                  :to="{
                    name: 'guia-profissionais-single',
                    params: { id: profissional.id },
                  }"
                >
                  Ver Profissional
                </router-link>
              </div>
            </div>
            <div v-else class="card-plan-free bg-gray-1 mb-4">
              <div
                class="d-flex flex-row justify-content-between align-items-center"
              >
                <span class="fs-16 font-weight-bold mb-2 text-overflow">
                  {{ profissional.nome_fantasia || profissional.nome }}
                </span>
                <span v-if="profissional.profissoes !== null">
                  <span class="roboto-n fs-14">
                    {{ profissional.profissoes[0].nome }}
                  </span>
                </span>
              </div>
              <div
                v-if="
                  profissional.celular !== null && profissional.celular !== ''
                "
              >
                <i class="fab fa-whatsapp fs-14 c-black mr-1"></i>
                <a
                  :href="'tel:+' + profissional.celular"
                  class="roboto-n fs-14 c-black"
                >
                  <the-mask
                    class="desinput"
                    v-model="profissional.celular"
                    :mask="['(##) #####-####', '(##) ####-####']"
                    readonly
                  />
                </a>
              </div>
              <div v-if="profissional.cidade !== null">
                <i class="fas fa-map-marker-alt fs-14 c-black mr-1"></i>
                <span class="roboto-n fs-14">
                  {{ profissional.cidade.nome }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Paginação -->
        <div class="row" v-if="!checkIsEmpty(profissionais)">
          <div class="col-12">
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center">
                <li class="page-item">
                  <div
                    class="page-link c-orange"
                    @click="paginacaoProf(paginaProfAtual - 1)"
                    aria-label="Previous"
                    v-if="paginaProfAtual > 1"
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </div>
                </li>
                <li
                  class="page-item"
                  v-for="(pagP, index) in profPaginacao"
                  :key="index"
                >
                  <div class="page-link c-black" @click="paginacaoProf(pagP)">
                    {{ pagP }}
                  </div>
                </li>
                <li class="page-item">
                  <div
                    class="page-link c-orange"
                    @click="paginacaoProf(paginaProfAtual + 1)"
                    aria-label="Next"
                    v-if="paginaProfAtual < profPaginacao.length"
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        profissionaisDestaques !== undefined &&
        profissionaisDestaques.length === 0 &&
        profissionais !== undefined &&
        profissionais.length === 0 &&
        !firstSearch
      "
      class="jumbotron text-center py-3"
    >
      <h3 class="display-4 roboto-b">Oops!</h3>
      <p class="fs-20">
        Parece que não existe nenhum profissional na cidade e serviço
        desejado.<br />
        Nós envie um
        <a
          target="_blank"
          rel="noopener noreferrer"
          class="text-success no-text-decoration"
          href="https://api.whatsapp.com/send?phone=5519992065613&text=Olá, estou procurando por um profissional na Constr Up.&source=&data=&app_absent="
        >
          WhatsApp
        </a>
        e diga qual o profissional que você está buscando e te
        disponibilizaremos uma lista com alguns contatos! &#x1F609;
      </p>
      <a
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-success fs-24 mt-4"
        href="https://api.whatsapp.com/send?phone=5519992065613&text=Olá, estou procurando por um profissional na Constr Up.&source=&data=&app_absent="
      >
        <i class="fab fa-whatsapp mr-2"></i>
        Enviar Mensagem
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ProfessionalPlans from "../../enums/ProfessionalPlans";
import UserTypes from "../../enums/UserTypes";
import scrollToElement from '../../mixins/scrollToElement';

export default {
  mixins:[scrollToElement],
  name: "guia-profissional-geral",
  data: () => ({
    UserTypes,
    ProfessionalPlans,
    firstSearch: true,
    paginaProfAtual: 1,
    paginaProfDestAtual: 1,
    pesquisar: {
      cidade: null,
      profissao: null,
    },
  }),
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cidades: (state) => state.cidades,
      tipoProfissoes: (state) => state.tipoProfissoes,
      profissionaisDestaques: (state) => state.profissionaisDestaques.dados,
      profDestPaginacao: (state) => {
        const pagMaxDest = state.profissionaisDestaques.paginacao;
        const pagArr = [];
        let x = 1;

        while (x <= pagMaxDest) {
          pagArr.push(x++);
        }

        return pagArr;
      },
      profissionais: (state) => state.profissionais.dados,
      profPaginacao: (state) => {
        const pagMax = state.profissionais.paginacao;
        const pagArr = [];
        let x = 1;

        while (x <= pagMax) {
          pagArr.push(x++);
        }

        return pagArr;
      },
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadTipoProfissoes');
    this.firstSearch = true;
    this.scrollToElement();
  },
  mounted() {
   this.scrollToElement();
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined' ||
        value === []
      ) {
        return true;
      }
      return false;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    paginacaoProf(idGeral) {
      const self = this;
      const values = {
        pag: idGeral,
        cidade: this.pesquisar.cidade,
        profissao: this.pesquisar.profissao,
      };
      this.paginaProfAtual = idGeral;
      this.$store
        .dispatch('getBronzeSilverGoldProfessionals', values)
        .then(() => {
          self.$store.dispatch('startLoader');
          setTimeout(() => {
            self.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          self.$store.dispatch('startLoader');
          setTimeout(() => {
            self.$store.dispatch('endLoader');
          }, 1000);
        });
    },
    paginacaoProfDesc(idDestaques) {
      const self = this;
      const values = {
        pag: idDestaques,
        cidade: this.pesquisar.cidade,
        profissao: this.pesquisar.profissao,
      };
      this.paginaProfDestAtual = idDestaques;
      this.$store
        .dispatch('getDiamondProfessionals', values)
        .then(() => {
          self.$store.dispatch('startLoader');
          setTimeout(() => {
            self.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          self.$store.dispatch('startLoader');
          setTimeout(() => {
            self.$store.dispatch('endLoader');
          }, 1000);
        });
    },
    searchProfissionais() {
      this.firstSearch = false;
      const self = this;
      const values = {
        pag: 1,
        cidade: this.pesquisar.cidade,
        profissao: this.pesquisar.profissao,
      };

      if (values.cidade === null && values.profissao === null) {
        self.aviso(
          'Por favor, selecione pelo menos um filtro para a pesquisa!',
          'warning'
        );
        return;
      }

      this.$store.dispatch('startLoader');

      this.paginaProfAtual = 1;
      this.paginaProfDestAtual = 1;

      Promise.all([
        this.$store.dispatch('getDiamondProfessionals', values),
        this.$store.dispatch('getBronzeSilverGoldProfessionals', values),
      ])
        .then(() => {
          setTimeout(() => {
            self.$store.dispatch('endLoader');
          }, 2000);
        })
        .catch(() => {
          self.$store.dispatch('endLoader');
        });
    },
    urlPainel() {
      if (!this.checkIsEmpty(this.dadosUsuario)) {
        if (this.dadosUsuario.tipo_usuario_id === 1) {
          return 'cliente-meus-dados';
        }
        if (this.dadosUsuario.tipo_usuario_id === 2) {
          return 'profissional-meus-dados';
        }
        if (this.dadosUsuario.tipo_usuario_id === 3) {
          return 'lojista-meus-dados';
        }
        if (this.dadosUsuario.tipo_usuario_id === 4) {
          return 'representante-meus-dados';
        }
      }
    },
  },
};
</script>
